import React from 'react';
import { withStyles } from '@mui/styles';
import lodashMerge from 'lodash/merge';

const withTableStyles = (specificStylesExtractor = () => ({})) => Component => {
    const styles = theme => {
        const specificStyles = specificStylesExtractor(theme);

        const styles = {
            table: {
                minWidth: 700
            },
            tableWrapper: {
                maxHeight: 'calc(100vh - 380px)',
                overflowX: 'auto',
                marginTop: theme.spacing(3),
                borderRadius: 'inherit',
                position: 'relative'
            },
            row: {
                backgroundColor: theme.palette.background.default
            }
        };

        return lodashMerge(styles, specificStyles);
    };

    function StyledTable(props) {
        return <Component {...props} />;
    }

    return withStyles(styles)(StyledTable);
};

export default withTableStyles;
